import { NotificationScopeBadge } from '@ayocore/platform/notifications/client';
import { CRM_LEADS_NOTIFICATION_SCOPE } from '../../notification-scopes';

/** Непрочитанные уведомления по лидам, включая уведомления связанных задач. */
export function LeadsMenuBadge() {
  return <NotificationScopeBadge scope={CRM_LEADS_NOTIFICATION_SCOPE} />;
}
